// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2x5eQ","Label":"Input_Label__1RqXX","InputElement":"Input_InputElement__3QVSI","Invalid":"Input_Invalid__3Dbxq"};